export default "__VITE_ASSET__DB62onGM__"